import axios from "axios";

const SYMBOLS = ["BTC", "ETH", "USDT", "USD", "EUR", "UAH"];

function buildCrossRates(usdValues) {
  const rates = {};

  for (const base of SYMBOLS) {
    rates[base] = {};
    for (const quote of SYMBOLS) {
      rates[base][quote] = usdValues[base] / usdValues[quote];
    }
  }

  return rates;
}

export default {
  state: {
    coinsRates: {},
  },
  getters: {
    coinsRates(state) {
      return state.coinsRates;
    },
  },
  mutations: {
    updateCoinsRates(state, coinsRates) {
      state.coinsRates = coinsRates;
    },
  },
  actions: {
    async getCoinsRates({ commit }) {
      const [cryptoResponse, fiatResponse] = await Promise.all([
        axios.get(
          "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,tether&vs_currencies=usd"
        ),
        axios.get("https://open.er-api.com/v6/latest/USD"),
      ]);

      const usdValues = {
        BTC: cryptoResponse.data.bitcoin.usd,
        ETH: cryptoResponse.data.ethereum.usd,
        USDT: cryptoResponse.data.tether.usd,
        USD: 1,
        EUR: 1 / fiatResponse.data.rates.EUR,
        UAH: 1 / fiatResponse.data.rates.UAH,
      };

      commit("updateCoinsRates", buildCrossRates(usdValues));
    },
  },
};
